import { render, staticRenderFns } from "./ConversationEditorReadOnly.vue?vue&type=template&id=81630f5e&"
import script from "./ConversationEditorReadOnly.vue?vue&type=script&lang=js&"
export * from "./ConversationEditorReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports